function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.coms1{fill-rule:evenodd;clip-rule:evenodd;fill:#75ceda;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "coms1",
  d: "M782.2,331.9C746.1,245.9,672.7,196,549,197.3c-20.9,5-41.9,10-62.8,14.9c-30.6,12.9-70.7,37.5-89.7,62.8 c-5.8,7.7-8.1,14.6-14.9,20.9c0.4,19.2,4.8,19.3,12,29.9c149.8-0.4,228.8,42.9,284,134.5c13.8,22.9,20.4,55.3,26.9,83.7 c4.4,19.4-3,37.5,6,50.8c7.7,11.5,28,9.6,38.9,17.9c9.5-1.7,8.7-2.6,14.9-6c-3.6-17.4-20.9-45.5-14.9-65.8 c3-10.4,15.6-18.8,20.9-26.9c15.3-23.6,22.9-55.9,29.9-86.7C808.3,392,791.2,353.2,782.2,331.9z M489.2,370.8 c-23.8-6.4-55.8-3.4-83.7-3c-17.6,11.4-46.9,9.8-65.8,17.9c-67.9,29.4-110.6,87.2-128.6,167.4c-21.5,95.7,83.8,147.5,35.9,215.3 c1,6.9,1.4,7.4,3,12c28.6-0.6,63.7-23.5,86.7-17.9c22.7,5.5,50.3,17.8,77.7,23.9c74.2,16.6,174.6-43.2,200.3-77.7 c16.4-22,32.8-49.7,41.9-77.7C701,494.4,581.8,395.6,489.2,370.8z"
})));

var SvgComs = function SvgComs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Coms.07be8da8.svg";
export { ForwardRef as ReactComponent };